import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { ApiClient } from '../../../../api-client';
import { UnitResult } from '../../../../error';
import { EventType } from '../../../Domain/Model/eventType';
import { EventTypesProvider } from '../../../Domain/Port/eventTypesProvider';

@Injectable({
    providedIn: 'root'
})
export class BackendEventTypesProvider extends EventTypesProvider {
    private readonly endpoint = '/events';

    constructor(private readonly apiClient: ApiClient) {
        super();
    }

    override getEvents(): Observable<UnitResult<EventType[]>> {
        return this.apiClient.get<EventType[]>(this.endpoint, true);
    }
}
